import { gql } from 'apollo-angular';

export const GET_OPERATION = gql`
  query ($id: ID!) {
    operationDetails(id: $id) {
      id
      status
      externalId
      externalCaseId
      title
      description
      amount {
        amount
        currency
        formattedAmount
      }
      payedAmount {
        amount
        currency
        formattedAmount
      }
      dueDate
      comment
      createdAt
      updatedAt
      pendingAmount {
        amount
        currency
        formattedAmount
      }
      collector {
        id
        name
      }
      items {
        concept
        amount
        formattedAmount
      }
      customers {
        id
        externalId
        nif
        name
        longName
        emailAddresses
        phones
        case {
          id
          name
        }
      }
      portfolio {
        id
        name
        alias
      }
      payments {
        id
        customerId
        dateTime
        amount
        formattedAmount
        paymentMethod
      }
    }
  }
`;

export const GET_OPERATIONS = gql`
  query ($criteria: SearchInOperationListCriteria!) {
    searchInOperationList(criteria: $criteria) {
      totalResults
      results {
        id
        externalId
        status
        title
        dueDate
        collector {
          id
          name
        }
        customers {
          id
          name
          nif
          externalId
          longName
        }
        amount {
          amount
          currency
          formattedAmount
        }
        payedAmount {
          amount
          currency
          formattedAmount
        }
        payments {
          id
          paymentDate
          amount {
            amount
          }
          method
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_OPERATION_STATUS = gql`
  query {
    operationStatus {
      id
      name
    }
  }
`;

export const GET_OPERATION_LIST_CRITERIA = gql`
  query ($criteria: OperationListCriteria!) {
    operationList(criteria: $criteria) {
      totalResults
      results {
        id
        title
        externalId
        status
        dueDate
        customers {
          id
          externalId
          name
          longName
        }
        pendingAmount {
          amount
          currency
          formattedAmount
        }
        collectorId
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_OPERATION_CUSTOM_FIELDS = gql`
  query ($operationId: ID!) {
    customFieldsByOperation(operationId: $operationId) {
      id
      key
      value
      operationId
    }
  }
`;

export const GET_OPERATION_CUSTOM_PLACE_HOLDERS = gql`
  query ($operationId: ID!) {
    customPlaceholdersByOperation(operationId: $operationId) {
      id
      key
      value
    }
  }
`;

export const MODIFY_OPERATION_STATUS = gql`
  mutation ($input: ChangeOperationStatusInput!, $ids: [ID!]!) {
    changeOperationsStatusByIds(input: $input, ids: $ids) {
      success
      failed
    }
  }
`;

export const MODIFY_OPERATION_STATUS_BY_FILTER = gql`
  mutation ($input: ChangeOperationsStatusByFilterInput!) {
    changeOperationsStatusByFilter(input: $input) {
      success
      failed
    }
  }
`;

export const UPDATE_OPERATION = gql`
  mutation ($id: ID!, $input: UpdateOperationInput!) {
    updateOperation(id: $id, input: $input) {
      id
      title
      amount
      currency
      formattedAmount
      dueDate
      comment
      description
      items {
        concept
        amount
        formattedAmount
      }
      attachmentUrl
    }
  }
`;

export const DELETE_OPERATION = gql`
  mutation ($ids: [ID!]!) {
    deleteOperations(ids: $ids) {
      success
      failed
    }
  }
`;

export const DELETE_OPERATIONS_BY_FILTER = gql`
  mutation ($input: DeleteOperationsByFilterInput!) {
    deleteOperationsByFilter(input: $input) {
      success
      failed
    }
  }
`;

export const EXPORT_OPERATIONS = gql`
  query ($fileId: ID!, $criteria: ExportOperationListCriteria!) {
    exportOperationList(fileId: $fileId, criteria: $criteria) {
      url
    }
  }
`;

export const CREATE_OPERATION_EXPORT = gql`
  mutation ($input: CreateOperationListExportInput!) {
    createOperationListExport(input: $input) {
      id
      tenantId
      type
      status
    }
  }
`;

export const FIND_OPERATION_EXPORT = gql`
  query ($id: ID!) {
    operationExport(id: $id) {
      id
      tenantId
      userId
      type
      status
      totalLines
      processedLines
      createdAt
      updatedAt
      remoteFile
      remoteFileExpireAt
    }
  }
`;

export const GET_OPERATION_PAYMENT = gql`
  query ($criteria: OperationPaymentsCriteria!) {
    operationPayments(criteria: $criteria) {
      id
      customerId
      amount {
        amount
        currency
        formattedAmount
      }
      method
      paymentDate
      paymentOrder {
        id
        number
        reference
        gatewayType
      }
      customer {
        id
        name
        longName
      }
      operations {
        id
        title
        status
        amount {
          amount
          currency
          formattedAmount
        }
        attributedAmount {
          amount
          currency
          formattedAmount
        }
      }
    }
  }
`;

export const CREATE_PAYMENT = gql`
  mutation ($input: CreatePaymentInput!) {
    createPayment(input: $input) {
      id
      customerId
      operationIds
      amount
      currency
      formattedAmount
      method
      paymentDate
    }
  }
`;

export const CHANGE_OPERATIONS_STATUS_BY_CRITERIA = gql`
  mutation ChangeOperationsStatusByCriteria($input: ChangeOperationsStatusByCriteriaInput!) {
    changeOperationsStatusByCriteria(input: $input) {
      success
      failed
    }
  }
`;

export const OPERATION_HISTORIC = gql`
  query ($id: ID!, $orderBy: SearchOperationHistoryOrderByInput) {
    searchOperationHistory(id: $id, orderBy: $orderBy) {
      eventName
      category
      parameters
      dateTime
      userId
    }
  }
`;

export const SEND_EMAIL_USAGE = gql`
  mutation ($input: SendEmailPaylinkNotificationUsageInput!) {
    sendEmailPaylinkNotificationUsage(input: $input) {
      status
    }
  }
`;

export const SEND_SMS_USAGE = gql`
  mutation ($input: SendSmsPaylinkNotificationUsageInput!) {
    sendSmsPaylinkNotificationUsage(input: $input) {
      status
    }
  }
`;

export const CREATE_OPERATION = gql`
  mutation ($input: CreateOperationInput!) {
    createOperation(input: $input) {
      id
      title
      amount
      currency
      formattedAmount
      dueDate
      items {
        concept
        amount
        formattedAmount
      }
    }
  }
`;

export const DELETE_OPERATIONS_BY_CRITERIA = gql`
  mutation DeleteOperationsByCriteria($input: DeleteOperationsByCriteriaInput!) {
    deleteOperationsByCriteria(input: $input) {
      success
      failed
    }
  }
`;
